// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"styles_containerMain__irPB9"};